import { create } from 'zustand'

/**
 * Central v2 auth identity store (in-memory only — nothing persisted).
 */

function identityFromUserInfo(info) {
  if (!info) return null
  return {
    id: info.userId,
    fullname: info.fullname,
    email: info.email,
    companyId: info.companyId,
    companyName: info.companyName,
    companyEmail: info.companyEmail,
    role: info.role,
    roleId: info.roleId,
    userTitle: info.userTitle,
    agencyId: info.agencyId,
    isAgency: info.isAgency ?? false,
    isActive: info.isActive ?? false,
  }
}

export const useAuthStore = create((set, get) => ({
  identity: null,

  isAuthenticated: () => Boolean(get().identity?.id),

  hydrateFromUserInfo: (info) => set({ identity: identityFromUserInfo(info) }),

  patchIdentity: (partial) =>
    set((state) => ({ identity: { ...(state.identity || {}), ...partial } })),

  clear: () => set({ identity: null }),
}))

export default useAuthStore
